import "./admin_dashboard.scss";

import { useState, useLayoutEffect, useEffect } from "react";
import DragContainer from "./Draggable/DragContainer";
import { automateFactory } from "../../../automation/automation";
import { useAuth } from "../../../authentication/authHelpers";
import axios from "axios";

function AdminDashboard() {
  const [alreadySent, setAlreadySent] = useState(false);
  const auth = useAuth();
  const ipResponse = {};
  const [ip, setIp] = useState("");
  const getIp = async () => {
    const res = await axios.get("https://api.ipify.org/?format=json");
    setIp(res?.data?.ip);
  };
  useLayoutEffect(() => {
    if (!alreadySent && !!auth) {
      automateFactory("requestsToApprovals", auth, {
        ...ipResponse,
        Ipv4: ip,
      })
        .then((res) => {
          // message.success("Automation Successful");
          console.log("Converted Requests to Approvals!", res);
        })
        .catch((err) => {
          // console.log("error", err);
          console.log(
            "THere was an error in the tasks converter requestsToApprovals",
            err
          );
        });
      setAlreadySent(true);
    }
  }, [auth]);
  useEffect(() => {
    getIp();
  }, []);

  return (
    // <LoaderComponent loading={tableData.length > 0 ? false : true}>
    // </LoaderComponent>
    <div className="admin-dashboard">
      <DragContainer view={"Admin"} floatingHeader={true} />
    </div>
  );
}

export default AdminDashboard;
